import { Sparkle24Regular } from "@fluentui/react-icons";
import { Box, Paper, Typography } from "@mui/material";
import React from "react";

// Theme colors
const THEME = {
  primary: "#0078D4",
  border: "#E1E5EB",
  surface: "#FFFFFF"
};

const TopThemes: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        px: 2,
        py: 1.5,
        borderRadius: "10px",
        border: `1px solid ${THEME.border}`,
        backgroundColor: THEME.surface
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Sparkle24Regular style={{ color: THEME.primary, width: 20, height: 20 }} />
        <Typography sx={{ color: THEME.primary, fontWeight: 700, fontSize: "13px" }}>
          TOP THEMES
        </Typography>
        <Box
          sx={{
            px: 1,
            py: 0.25,
            borderRadius: "4px",
            backgroundColor: "#FFF4CE",
            fontSize: "11px",
            fontWeight: 600,
            color: "#8A5E00"
          }}
        >
          Coming Soon
        </Box>
      </Box>
    </Paper>
  );
};

export default TopThemes;
